module.exports = __webpack_public_path__ + "img/Capa 6@2x.dcb89d12.png";